<button class="btn rounded-0" type="button" (click)="toggleToPortfolio(portfolio)" [matTooltip]="portfolio ? 'Remove from Portfolio' : 'Add to Portfolio'" matTooltipPosition="below">
  <i class="bi bi-pie-chart-fill fs-4" [ngClass]="portfolio ? 'text-primary' : 'text-body-tertiary'"></i>
</button>
